import React from 'react';

export type OnPromptClose = () => void;

export const OnPromptCloseContext = React.createContext<OnPromptClose>(() => {});
